// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"b32d6d2d","214":"e60c30cc","307":"3b7f4914","521":"642ffab5","638":"00b906cb","715":"15f8ba4a"}[chunkId] + ".chunk.js";
};